import React from 'react';
import { NavLink } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useAdminMenuItems } from './adminMenuConfig';

const AdminSideMenu: React.FC = () => {
  const menuItems = useAdminMenuItems();

  return (
    <nav
      className="col-md-3 col-lg-2 d-none d-md-block bg-dark sidebar"
      style={{ minHeight: 'calc(100vh - 56px)' }}
      aria-label="Admin bölümleri"
    >
      <div className="position-sticky pt-3">
        <ul className="nav flex-column">
          {menuItems.map(({ path, label, icon }) => (
            <li key={path} className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  `nav-link text-white ${isActive ? 'active bg-primary' : ''}`
                }
                to={path}
              >
                <i className={`fas ${icon} me-2`} />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default AdminSideMenu;
